import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useMediaQuery } from '@mantine/hooks'
import {
  curriculumDetailList,
  projectSlideList,
  reviewSlideList,
  supportSlideList,
  supportDetailList,
  firstCompanyList,
  secondCompanyList,
  benefitSlideList,
  bootCampFaqList,
  bootCampFaqTabList,
  CldApplyScheduleList,
  AfterCldApplyScheduleList,
  CldEduScheduleList,
} from '../../../../constants/kdt-cld-3rd'
import Aos from 'aos'
import Link from 'next/link'
import Image from 'next/image'
import ReactPlayer from 'react-player'
import { useState, useEffect, useMemo } from 'react'

import { CurriculumAccordion } from './CurriculumAccordion'
import CurriculumTab from './CurriculumTab'
import ProgramAccordion from './ProgramAccordion'
import ProgramTab from './ProgramTab'
import {
  ProjectSliderItem,
  SupportSliderItem,
  ReviewSliderItem,
  BenefitSliderItem,
} from './CloudSliderItem'
import styles from './kdt-cld-3rd.module.scss'
import { schoolNavList, ScrollNav } from './ScrollNav'

const CloudKlass3rd = () => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const [faqTab, setFaqTab] = useState('apply')

  const allFaqs = [
    ...bootCampFaqList.apply,
    ...bootCampFaqList.nebeka,
    ...bootCampFaqList.employment,
    ...bootCampFaqList.edu,
    ...bootCampFaqList.benefit,
    ...bootCampFaqList.etc,
  ]

  const faqList = faqTab === 'all' ? allFaqs : bootCampFaqList[faqTab]
  const onClickFaqTab = (value: string) => {
    setFaqTab(value)
  }

  const [imageLoaded, setImageLoaded] = useState(false)

  useEffect(() => {
    Aos.init()
  }, [])

  const handleImageLoad = () => {
    setImageLoaded(true)
    setTimeout(() => {
      Aos.refresh()
    }, 100)
  }

  return (
    <div>
      {/* Section1_키비주얼 */}
      <section className="bg-[#1c1b1a]">
        <div className={`${styles.section1_kv} relative w-full`}>
          <div className="absolute left-0 top-0 w-full">
            <img
              onLoad={handleImageLoad}
              className="relative z-10 w-full object-cover"
              src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section1_kv_after_load_${
                isMobile ? 'm' : 'pc'
              }.png`}
              alt="kv bg"
            />
          </div>
          {imageLoaded && (
            <>
              <div className="absolute left-0 top-0 w-full">
                <img
                  data-aos-once="true"
                  data-aos="fade-up"
                  data-aos-easing="ease"
                  data-aos-duration="800"
                  data-aos-delay="600"
                  className="relative z-10 w-full object-cover"
                  src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section1_kv_main_title_${
                    isMobile ? 'm' : 'pc'
                  }.png`}
                  alt="대규모 트래픽 프로젝트로 완성되는 [AWS 클라드 엔지니어링]"
                />
              </div>
            </>
          )}
        </div>
      </section>

      {/* Section2_요약정보 */}
      <section className="bg-gray-900 py-10 lg:py-20">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 lg:gap-8 lg:px-6">
          <ul className="flex w-full flex-col gap-3 lg:flex-row lg:gap-4">
            <li className="flex flex-1 flex-row items-center justify-center gap-3 rounded-lg bg-[#1F1F1F] px-4 py-3 lg:gap-4 lg:px-6 lg:py-5">
              <img
                className="h-[72px] w-[72px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section2_img1.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-2 inline-block rounded bg-[rgba(255,119,16,0.10)] px-2 py-1 text-[10px] font-semibold text-yellow-450 lg:px-3 lg:text-xs lg:font-bold">
                  POINT 1
                </p>
                <p className="text-sm font-semibold leading-normal text-white lg:text-lg">
                  대규모 트래픽 경험을 통한
                  <br />
                  핵심 취업 역량 강화
                </p>
              </div>
            </li>
            <li className="flex flex-1 flex-row items-center justify-center gap-3 rounded-lg bg-[#1F1F1F] px-4 py-3 lg:gap-4 lg:px-6 lg:py-5">
              <img
                className="h-[72px] w-[72px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section2_img2.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-2 inline-block rounded bg-[rgba(255,119,16,0.10)] px-2 py-1 text-[10px] font-semibold text-yellow-450 lg:px-3 lg:text-xs lg:font-bold">
                  POINT 2
                </p>
                <p className="text-sm font-semibold leading-normal text-white lg:text-lg">
                  AWS 클라우드에 웹 개발을 더한
                  <br />
                  실무 최적화 커리큘럼
                </p>
              </div>
            </li>
            <li className="flex flex-1 flex-row items-center justify-center gap-3 rounded-lg bg-[#1F1F1F] px-4 py-3 lg:gap-4 lg:px-6 lg:py-5">
              <img
                className="h-[72px] w-[72px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section2_img3.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-2 inline-block rounded bg-[rgba(255,119,16,0.10)] px-2 py-1 text-[10px] font-semibold text-yellow-450 lg:px-3 lg:text-xs lg:font-bold">
                  POINT 3
                </p>
                <p className="text-sm font-semibold leading-normal text-white lg:text-lg">
                  AWS 클라우드 리소스 및 <br className="hidden lg:block" />
                  자격증 비용 <br className="block lg:hidden" />
                  전액 지원
                </p>
              </div>
            </li>
          </ul>
          <hr className="border-[#525252] lg:hidden" />
          <ul className="flex w-full flex-col">
            <li className="flex w-full flex-row items-start border-b border-[#3D3D3D] pb-3 lg:items-center lg:pb-4">
              <h6 className="flex w-[126px] flex-row items-center justify-start gap-3 text-sm font-semibold text-white lg:w-[calc(33.33%+16px)] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section2_icon1.png"
                  alt="-"
                />
                모집기간
              </h6>
              <p className="text-sm text-label-assistive lg:w-2/3 lg:text-base">
                25.02.14 (금) 오전 11시 ~ <br className="block lg:hidden" />
                25.03.25 (화) 오후 6시
              </p>
            </li>
            <li className="flex w-full flex-row items-center border-b border-[#3D3D3D] py-3 lg:py-4">
              <h6 className="flex w-[126px] flex-row items-center justify-start gap-3 text-sm font-semibold text-white lg:w-[calc(33.33%+16px)] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src={
                    'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section2_icon2.png'
                  }
                  alt="-"
                />
                교육기간
              </h6>
              <p className="text-sm text-label-assistive lg:w-2/3 lg:text-base">
                25.03.27 (목) ~ <br className="block lg:hidden" />
                25.08.22 (금)
              </p>
            </li>
            <li className="flex w-full flex-row items-start pt-3 lg:pt-4">
              <h6 className="flex w-[126px] flex-row items-center justify-start gap-3 text-sm font-semibold text-white lg:w-[calc(33.33%+16px)] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src={
                    'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section2_icon3.png'
                  }
                  alt="-"
                />
                교육비용
              </h6>
              <p className="text-sm text-label-assistive lg:w-2/3 lg:text-base">
                내일배움카드로 교육비 전액 무료 <br className="block lg:hidden" />
                <span className="line-through">14,520,000</span>원{' '}
                <br className="block lg:hidden" />
                <span className="hidden lg:inline-block">/</span> 매월 최대 81만원 지원금 신청 가능
              </p>
            </li>
          </ul>

          <div className="overflow-hidden rounded-lg border border-yellow-450 bg-[rgba(255,119,16,0.10)] px-4 py-3 lg:p-10">
            <div className="flex cursor-pointer flex-row lg:cursor-default">
              <h5 className="flex-1 text-lg font-bold text-white lg:text-2xl">
                내일배움카드 & 지원 대상
              </h5>
            </div>
            {/* open */}
            <ul className="mt-3 flex w-full flex-col gap-2 lg:mt-6 lg:gap-1.5">
              <li
                className={`${styles.text_dot} ${styles.text_dot_section2} text-[13px] leading-normal text-white lg:text-base`}
              >
                국민내일배움카드 보유자 혹은 발급 가능하신 분
              </li>
              <li
                className={`${styles.text_dot} ${styles.text_dot_section2} text-[13px] leading-normal text-white lg:text-base`}
              >
                평일 오전 9시부터 오후 6시 까지 수업 참여 가능하신 분
              </li>
              <li
                className={`${styles.text_dot} ${styles.text_dot_section2} text-[13px] leading-normal text-white lg:text-base`}
              >
                직장 혹은 학교 등과 병행하지 않고 수업에만 집중 <br className="block lg:hidden" />
                가능하신 분
              </li>
              <li
                className={`${styles.text_dot} ${styles.text_dot_section2} text-[13px] leading-normal text-white lg:text-base`}
              >
                국내에 거주하고 계신 분
              </li>
              <li
                className={`${styles.text_dot} ${styles.text_dot_section2} text-[13px] leading-normal text-white lg:text-base`}
              >
                <Link href="/nebeca" target="_blank" className="underline">
                  내일배움카드 발급 방법 확인하기
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <ScrollNav schoolNavList={schoolNavList} />

      {/* Section5_교육일정 */}
      <section className="bg-trueGray-800 py-[50px] lg:pb-36 lg:pt-[120px]">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">
              2025년 채용트렌드 반영한 실무 커리큘럼
            </p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              웹 개발부터 AWS 클라우드까지
              <br />
              취업하는 포트폴리오를 만들어 갑니다
            </h4>
            <p className="text-center text-xs leading-normal text-label-assistive lg:text-lg">
              이론부터 실무 기반 3가지 프로젝트를 순차적으로 진행하며
              <br />
              AWS 클라우드 엔지니어의 핵심 역량을 완성합니다.
            </p>
          </div>
          <div className={`${styles.section5_mediaquery} flex w-full flex-col gap-4 lg:gap-5`}>
            <div
              data-aos-once="true"
              data-aos="fade-right"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex w-full flex-col overflow-hidden rounded-lg"
            >
              <div className="flex flex-row items-center gap-4 overflow-hidden rounded-lg bg-[rgba(255,255,255,0.05)] lg:w-[530px] lg:gap-10">
                <img
                  className="w-[70px] object-cover lg:w-24"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section5_img1.png"
                  alt="-"
                />
                <p className="text-base font-bold text-white lg:text-xl">1. 웹 개발 기본</p>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-right"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="800"
              className="flex w-full flex-col overflow-hidden rounded-lg"
            >
              <div className="flex flex-row items-center gap-4 overflow-hidden rounded-lg bg-[rgba(255,255,255,0.05)] lg:ml-[20%] lg:w-[530px] lg:gap-10">
                <img
                  className="w-[70px] object-cover lg:w-24"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section5_img2.png"
                  alt="-"
                />
                <p className="text-base font-bold text-white lg:text-xl">2. 인프라 설계 및 구축</p>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-right"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="1000"
              className="flex w-full flex-col overflow-hidden rounded-lg"
            >
              <div className="flex flex-row items-center gap-4 overflow-hidden rounded-lg bg-[rgba(255,255,255,0.05)] lg:ml-[40%] lg:w-[530px] lg:gap-10">
                <img
                  className="w-[70px] object-cover lg:w-24"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section5_img3.png"
                  alt="-"
                />
                <p className="text-base font-bold text-white lg:text-xl">
                  3. AWS 클라우드 엔지니어링 기초
                </p>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-right"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="1200"
              className="flex w-full flex-col overflow-hidden rounded-lg"
            >
              <div className="flex flex-row items-center gap-4 overflow-hidden rounded-lg bg-[rgba(255,255,255,0.05)] lg:ml-auto lg:w-[530px] lg:gap-10">
                <img
                  className="w-[70px] object-cover lg:w-24"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section5_img4.png"
                  alt="-"
                />
                <p className="text-base font-bold text-white lg:text-xl">
                  4. AWS 클라우드 엔지니어링 심화
                </p>
              </div>
            </div>
          </div>
          <div className="mx-auto my-10 w-7 lg:my-16 lg:w-11">
            <img
              className={`${styles.section5_icon_arrow} w-full object-contain`}
              src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section5_icon_arrow.png"
              alt="-"
            />
          </div>
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mb-10 rounded-lg border border-yellow-450 bg-[rgba(255,119,16,0.10)] py-4 lg:mb-16 lg:px-6 lg:py-5"
          >
            <p className="text-center text-base font-bold leading-normal text-white lg:text-2xl">
              레거시, AWS 클라우드, 하이브리드를 <br className="block lg:hidden" />
              직접 구현해보는 3가지 프로젝트
            </p>
          </div>
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="800"
            className={`${styles.section5_slider} overflow-hidden lg:rounded-lg lg:bg-[#313131] lg:px-6 lg:py-10`}
          >
            <div className="lg:min-h-[365px] lg:px-16">
              <ProjectSliderItem contents={projectSlideList} />
            </div>
          </div>
        </div>
      </section>

      {/* Section6_커리큘럼 */}
      <section id="curriculum" className="bg-gray-900 py-[50px] lg:pb-[144px] lg:pt-[120px]">
        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <div className="mb-10 flex flex-row items-center justify-center lg:mb-16 lg:items-end lg:justify-between">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="flex flex-col items-center justify-center gap-2 lg:items-start lg:justify-start lg:gap-4"
            >
              <p className="text-sm font-bold text-yellow-450 lg:text-lg">주차별 핵심 커리큘럼</p>
              <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-left lg:text-4xl lg:leading-[1.4]">
                백엔드부터 인프라 구축까지,
                <br />
                DevOps 전 과정을 하나도 빠짐없이!
              </h4>
              <p className="text-center text-sm leading-normal text-label-assistive lg:text-left lg:text-lg">
                AWS 아키텍처와 EC2, S3, RDS 등 주요 서비스를 비롯해{' '}
                <br className="block lg:hidden" />
                Docker, Kubernetes 등 <br className="hidden lg:block" />
                가상화 기술을 학습하며 <br className="block lg:hidden" />
                실무 기반 대규모 트래픽 프로젝트까지 경험할 수 있습니다.
              </p>
            </div>

            <Link
              href="https://www.notion.so/likelion/3-17b44860a4f480ea9123e387dde84c05"
              target="_blank"
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="group hidden cursor-pointer flex-row items-center gap-2 rounded-lg border border-label-neutral px-5 py-4 hover:border-white hover:bg-white lg:flex"
            >
              <p className="text-base font-bold text-white group-hover:text-label-normal">
                상세 커리큘럼 다운로드
              </p>
              <img
                className="h-5 w-5 group-hover:hidden"
                src={
                  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section4_btn_download.png'
                }
                alt="Download"
              />
              <img
                className="hidden h-5 w-5 group-hover:block"
                src={
                  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section4_btn_download_hover.png'
                }
                alt="Download"
              />
            </Link>
          </div>
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className={`${styles.curriculum_accordion_wrap} hidden flex-row overflow-hidden rounded-lg bg-trueGray-800 lg:flex`}
          >
            <CurriculumTab curriculumDetailList={curriculumDetailList} />
          </div>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className={`${styles.curriculum_accordion_wrap} flex flex-col overflow-hidden lg:hidden`}
          >
            {curriculumDetailList.map((curriculum, idx) => (
              <CurriculumAccordion contents={curriculum} key={curriculum.title} idx={idx} />
            ))}
          </ul>

          <Link
            href="https://www.notion.so/likelion/3-17b44860a4f480ea9123e387dde84c05"
            target="_blank"
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="group mx-4 mt-10 flex cursor-pointer flex-row items-center justify-center gap-2 rounded-lg border border-label-neutral px-2 py-2.5 hover:border-white hover:bg-white lg:hidden"
          >
            <p className="text-sm font-bold text-white group-hover:text-label-normal">
              상세 커리큘럼 다운로드
            </p>
            <img
              className="h-4 w-4 group-hover:hidden"
              src={
                'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section4_btn_download.png'
              }
              alt="Download"
            />
            <img
              className="hidden h-4 w-4 group-hover:block"
              src={
                'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-2nd/section4_btn_download_hover.png'
              }
              alt="Download"
            />
          </Link>
        </div>
      </section>

      {/* Section7_채용트렌드 */}
      <section className="bg-alternative py-[50px] lg:pb-36 lg:pt-[120px]">
        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-[46px] flex flex-col items-center justify-center gap-2 lg:mb-16 lg:items-start lg:justify-start lg:gap-4"
          >
            <h4 className="text-center text-xl font-bold leading-snug text-label-normal lg:text-left lg:text-4xl lg:leading-[1.4]">
              2025 채용 트렌드 필수 역량
              <br />
              대용량 데이터 & 트래픽 경험
            </h4>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.custom_flow_slider_wrap} overflow-hidden`}
          >
            <div className={`${styles.custom_flow_slider}`}>
              <div className={`${styles.custom_flow_slider_track}`}>
                {[...firstCompanyList, ...firstCompanyList].map(item => (
                  <div
                    className={`${styles.custom_flow_slider_item} overflow-hidden`}
                    key={item.title}
                  >
                    <div className="h-[122px] w-[232px] rounded-lg bg-[rgba(38,38,38,0.05)] px-4 py-3 lg:h-40 lg:w-[316px] lg:px-6 lg:py-5">
                      <div className="flex flex-col">
                        <div className="flex flex-row items-center gap-3">
                          <img
                            src={item.imgUrl}
                            className="h-8 w-8 object-cover lg:h-10 lg:w-10"
                            loading="lazy"
                            alt={item.title}
                          />
                          <p className="text-base font-semibold text-label-normal lg:text-lg">
                            {item.title}
                          </p>
                        </div>
                        <div className="mt-3 border-t border-normal pt-3 lg:mt-4 lg:pt-4">
                          <p className="whitespace-pre-wrap text-sm leading-normal text-label-neutral lg:text-base">
                            {item.desc1 && <span>{item.desc1}</span>}
                            {item.bold && (
                              <span className="font-bold text-label-normal">{item.bold}</span>
                            )}
                            {item.desc2 && <span>{item.desc2}</span>}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={`${styles.custom_flow_slider} ${styles.custom_flow_slider_second} `}>
              <div className={`${styles.custom_flow_slider_track}`}>
                {[...secondCompanyList, ...secondCompanyList, ...secondCompanyList].map(item => (
                  <div
                    className={`${styles.custom_flow_slider_item} overflow-hidden`}
                    key={item.title}
                  >
                    <div className="h-[122px] w-[232px] rounded-lg bg-[rgba(38,38,38,0.05)] px-4 py-3 lg:h-40 lg:w-[316px] lg:px-6 lg:py-5">
                      <div className="flex flex-col">
                        <div className="flex flex-row items-center gap-3">
                          <img
                            src={item.imgUrl}
                            className="h-8 w-8 object-cover lg:h-10 lg:w-10"
                            loading="lazy"
                            alt={item.title}
                          />
                          <p className="text-base font-semibold text-label-normal lg:text-lg">
                            {item.title}
                          </p>
                        </div>
                        <div className="mt-3 border-t border-normal pt-3 lg:mt-4 lg:pt-4">
                          <p className="whitespace-pre-wrap text-sm leading-normal text-label-neutral lg:text-base">
                            {item.bold && (
                              <span className="font-bold text-label-normal">{item.bold}</span>
                            )}
                            {item.desc2 && <span>{item.desc2}</span>}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section8_최종 프로젝트 */}
      <section id="project" className="bg-fill-strong py-[50px] lg:pb-36 lg:pt-[120px]">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-1 flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <h4 className="text-center text-xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              <span className="text-yellow-450">대용량 트래픽 경험</span>을 위한
              <br />
              하이브리드 클라우드 <br className="block lg:hidden" />
              인프라 구축 프로젝트
            </h4>
            <p className="text-center text-sm leading-normal text-label-neutral lg:text-lg">
              하이브리드 클라우드 아키텍처 설계부터
              <br />
              대규모 트래픽 처리까지 경험하는 실무 중심 프로젝트로
              <br />
              나만의 강력한 취업 포트폴리오를 완성합니다.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex flex-col gap-8 rounded bg-white px-4 py-5 lg:flex-row lg:gap-10 lg:rounded-lg lg:p-10"
          >
            <div className="flex w-full shrink-0 flex-col lg:w-1/2">
              <h5 className="mb-5 block text-center text-xl font-bold text-label-normal lg:hidden">
                프로젝트 목표
              </h5>
              <Image
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section8_img1.gif"
                layout="fill"
                objectFit="cover"
                className="!relative h-full w-full rounded"
                alt="-"
                unoptimized
              />
            </div>
            <div className="flex flex-1 flex-col lg:gap-3.5">
              <p className="hidden max-w-fit rounded border border-yellow-450 bg-[rgba(255,119,16,0.1)] px-2 py-1 text-xl font-bold text-yellow-450 lg:inline-block">
                프로젝트 목표
              </p>
              <dl className="flex flex-col gap-3 lg:gap-0.5">
                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    하이브리드 클라우드 아키텍처 설계 및 구축
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    클라우드와 온프레미스 효율적 연동을 위한 아키텍처 설계
                  </dd>
                </div>

                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    어플리케이션 구현
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    대규모 트래픽 처리가 가능한 안정적이고 확장 가능한 서비스 설계 및 개발
                  </dd>
                </div>

                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    CI/CD 파이프라인 구축
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    GitHub Actions 등의 도구를 활용해 지속적인 통합 및 배포 환경을 구현
                  </dd>
                </div>

                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    트래픽 테스트 및 장애 대응 전략 수립
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    부하 테스트와 장애 복구 시나리오를 통해 시스템 안정성을 확보
                  </dd>
                </div>

                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    인프라 운영 및 모니터링
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    CloudWatch, Prometheus 등의 모니터링 도구를 활용한 지표 확인 및 운영
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="800"
            className="mt-[50px] flex flex-col gap-8 rounded bg-white px-4 py-5 lg:mt-6 lg:flex-row lg:gap-10 lg:rounded-lg lg:p-10"
          >
            <div className="flex w-full shrink-0 flex-col lg:w-1/2">
              <h5 className="mb-5 block text-center text-xl font-bold text-label-normal lg:hidden">
                주요 향상 역량
              </h5>
              <Image
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section8_img2_blur.png"
                layout="fill"
                objectFit="cover"
                className="!relative h-full w-full rounded"
                alt="-"
              />
            </div>
            <div className="flex flex-1 flex-col lg:gap-3.5">
              <p className="hidden max-w-fit rounded border border-yellow-450 bg-[rgba(255,119,16,0.1)] px-2 py-1 text-xl font-bold text-yellow-450 lg:inline-block">
                주요 향상 역량
              </p>
              <dl className="flex flex-col gap-3 lg:gap-0.5">
                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    복합 IT 환경 통합 역량 강화
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    클라우드와 온프레미스를 통합하여 하이브리드 아키텍처를 설계
                  </dd>
                </div>

                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    DevOps 자동화 기술 숙련
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    CI/CD 파이프라인 구현 및 자동화 프로세스를 통해 운영 효율성을 극대화
                  </dd>
                </div>

                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    백엔드 운영 능력 향상
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    대규모 트래픽 처리, 장애 대응, 성능 최적화를 포함한 운영 능력 학습
                  </dd>
                </div>

                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    종합 실무 기술 완성
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    클라우드, DevOps, 백엔드 시스템의 통합적 운영과 모니터링을 경험하며 IT
                    전문가로서의 종합적인 기술 역량 향상
                  </dd>
                </div>

                <div role="group" className="flex flex-col gap-2 lg:gap-0">
                  <dt className="text-sm font-bold text-label-normal lg:text-lg">
                    협업 역량 및 커뮤니케이션 스킬 향상
                  </dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section8} text-xs leading-normal text-label-neutral lg:text-base`}
                  >
                    1개월 이상 진행되는 팀 프로젝트를 통해 협업 역량 향상
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <h4
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mt-[50px] border-t border-normal pt-[50px] text-center text-xl font-bold leading-snug text-label-normal lg:my-16 lg:border-0 lg:pt-0 lg:text-4xl lg:leading-[1.4]"
          >
            프로젝트 진행 방식
          </h4>

          <ul className="mt-10 flex flex-col gap-2.5 lg:mt-16 lg:flex-row lg:flex-wrap lg:gap-6">
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex w-full flex-row items-center justify-center gap-4 rounded bg-white py-2.5 lg:w-[calc(33.33%-16px)] lg:justify-start lg:gap-6 lg:rounded-lg lg:px-6 lg:py-5"
            >
              <span className="inline-block max-w-fit rounded bg-[rgba(255,119,16,0.1)] px-2 py-1 text-[10px] font-extrabold text-yellow-450 lg:px-4 lg:py-1.5 lg:text-lg">
                STEP 1
              </span>
              <p className="w-[124px] text-sm font-bold text-label-neutral lg:w-auto lg:flex-1 lg:text-xl">
                주제 선정 및 역할 분담
              </p>
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="700"
              className="flex w-full flex-row items-center justify-center gap-4 rounded bg-white py-2.5 lg:w-[calc(33.33%-16px)] lg:justify-start lg:gap-6 lg:rounded-lg lg:px-6 lg:py-5"
            >
              <span className="inline-block max-w-fit rounded bg-[rgba(255,119,16,0.1)] px-2 py-1 text-[10px] font-extrabold text-yellow-450 lg:px-4 lg:py-1.5 lg:text-lg">
                STEP 2
              </span>
              <p className="w-[124px] text-sm font-bold text-label-neutral lg:w-auto lg:flex-1 lg:text-xl">
                프로젝트 기획 및 설계
              </p>
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="800"
              className="flex w-full flex-row items-center justify-center gap-4 rounded bg-white py-2.5 lg:w-[calc(33.33%-16px)] lg:justify-start lg:gap-6 lg:rounded-lg lg:px-6 lg:py-5"
            >
              <span className="inline-block max-w-fit rounded bg-[rgba(255,119,16,0.1)] px-2 py-1 text-[10px] font-extrabold text-yellow-450 lg:px-4 lg:py-1.5 lg:text-lg">
                STEP 3
              </span>
              <p className="w-[124px] text-sm font-bold text-label-neutral lg:w-auto lg:flex-1 lg:text-xl">
                개발 및 인프라 구축
              </p>
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="900"
              className="flex w-full flex-row items-center justify-center gap-4 rounded bg-white py-2.5 lg:w-[calc(33.33%-16px)] lg:justify-start lg:gap-6 lg:rounded-lg lg:px-6 lg:py-5"
            >
              <span className="inline-block max-w-fit rounded bg-[rgba(255,119,16,0.1)] px-2 py-1 text-[10px] font-extrabold text-yellow-450 lg:px-4 lg:py-1.5 lg:text-lg">
                STEP 4
              </span>
              <p className="w-[124px] text-sm font-bold text-label-neutral lg:w-auto lg:flex-1 lg:text-xl">
                모니터링
              </p>
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="1000"
              className="flex w-full flex-row items-center justify-center gap-4 rounded bg-white py-2.5 lg:w-[calc(33.33%-16px)] lg:justify-start lg:gap-6 lg:rounded-lg lg:px-6 lg:py-5"
            >
              <span className="inline-block max-w-fit rounded bg-[rgba(255,119,16,0.1)] px-2 py-1 text-[10px] font-extrabold text-yellow-450 lg:px-4 lg:py-1.5 lg:text-lg">
                STEP 5
              </span>
              <p className="w-[124px] text-sm font-bold text-label-neutral lg:w-auto lg:flex-1 lg:text-xl">
                테스트
              </p>
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="1100"
              className="flex w-full flex-row items-center justify-center gap-4 rounded bg-white py-2.5 lg:w-[calc(33.33%-16px)] lg:justify-start lg:gap-6 lg:rounded-lg lg:px-6 lg:py-5"
            >
              <span className="inline-block max-w-fit rounded bg-[rgba(255,119,16,0.1)] px-2 py-1 text-[10px] font-extrabold text-yellow-450 lg:px-4 lg:py-1.5 lg:text-lg">
                STEP 6
              </span>
              <p className="w-[124px] text-sm font-bold text-label-neutral lg:w-auto lg:flex-1 lg:text-xl">
                수료식 발표
              </p>
            </li>
          </ul>

          <p
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="1200"
            className="mt-2.5 text-center text-xs font-medium text-label-alternative lg:mt-10 lg:text-base"
          >
            * 프로젝트 방식은 팀별 주제에 따라 상이하게 진행될 수 있습니다.
          </p>
        </div>
      </section>

      {/* Section9_수료생 결과물 */}
      <section className="bg-strong py-[50px] lg:py-36 lg:pb-40">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">수료생 결과물</p>
            <h4 className="text-center text-xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              먼저 시작한 수강생들의
              <br />
              프로젝트 결과를 직접 확인하세요
            </h4>
            <p className="text-center text-xs leading-normal text-label-neutral lg:text-lg">
              레거시, AWS 클라우드, 하이브리드를 스스로 구현해 보는 <br />
              3가지 실무 기반 프로젝트로 기업이 <br className="block lg:hidden" />
              원하는 핵심 역량을 키워갑니다.
            </p>
          </div>

          <div className="flex flex-col gap-4 lg:flex-row lg:gap-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-col overflow-hidden rounded-lg"
            >
              <Image
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section9_img1.gif"
                layout="fill"
                objectFit="cover"
                className="!relative h-full w-full"
                alt="-"
                unoptimized
              />
              <div className="lg:py-3.6 flex flex-col gap-2 bg-fill-strong px-4 py-3 lg:flex-col lg:gap-2.5 lg:px-5">
                <h6 className="text-base font-bold leading-normal text-label-normal lg:text-xl">
                  [클라우드 엔지니어링 1기]
                  <br />
                  ’나야, 클라우드’ 팀 프로젝트
                </h6>
                <p className="text-sm text-label-neutral lg:text-lg">
                  AWS 기반 하이브리드 환경 구축
                </p>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="800"
              className="flex flex-col overflow-hidden rounded-lg"
            >
              <Image
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section9_img2.gif"
                layout="fill"
                objectFit="cover"
                className="!relative h-full w-full"
                alt="-"
                unoptimized
              />
              <div className="lg:py-3.6 flex flex-col gap-2 bg-fill-strong px-4 py-3 lg:flex-col lg:gap-2.5 lg:px-5">
                <h6 className="text-base font-bold leading-normal text-label-normal lg:text-xl">
                  [클라우드 엔지니어링 1기]
                  <br />
                  ’AWSome’ 팀 프로젝트
                </h6>
                <p className="text-sm text-label-neutral lg:text-lg">
                  AWS 기반 하이브리드 환경 구축
                </p>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="1000"
              className="flex flex-col overflow-hidden rounded-lg"
            >
              <Image
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section9_img3.gif"
                layout="fill"
                objectFit="cover"
                className="!relative h-full w-full"
                alt="-"
                unoptimized
              />
              <div className="lg:py-3.6 flex flex-col gap-2 bg-fill-strong px-4 py-3 lg:flex-col lg:gap-2.5 lg:px-5">
                <h6 className="text-base font-bold leading-normal text-label-normal lg:text-xl">
                  [클라우드 엔지니어링 1기]
                  <br />
                  개인 프로젝트
                </h6>
                <p className="text-sm text-label-neutral lg:text-lg">
                  AWS 기반 실시간 멀티 플레이어 게임 서비스 구축
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section10_수강혜택 */}
      <section className="bg-trueGray-800 py-[50px] lg:pb-36 lg:pt-[120px]">
        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">수강 혜택</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              수강생을 위한 특별 지원 혜택
            </h4>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section10_mediaquery} hidden flex-row gap-6 lg:flex`}
          >
            {supportSlideList.map(({ desc, title, imgUrlPc }) => (
              <div
                className="flex h-[367px] w-[calc(25%-18px)] flex-col justify-center overflow-hidden rounded-lg bg-gray-900"
                key={title}
              >
                <div className="h-[200px] w-full">
                  <Image
                    src={imgUrlPc as string}
                    layout="fill"
                    objectFit="cover"
                    className="!relative h-full w-full"
                    alt="-"
                  />
                </div>
                <div className="flex flex-1 flex-col gap-1 p-5">
                  <h6 className="whitespace-pre-wrap text-lg font-bold text-white">{title}</h6>
                  <p className="whitespace-pre-wrap text-base leading-normal text-label-assistive">
                    {desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="block lg:hidden"
          >
            <SupportSliderItem contents={supportSlideList} />
          </div>
        </div>
      </section>

      {/* Section11_강사진 */}
      <section id="teacher" className="bg-gray-900 py-[50px] lg:pb-36 lg:pt-[120px]">
        <div className="mx-auto mb-16 w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">처음부터 끝까지 함께하는</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              클라우드 엔지니어링 전문 강사
            </h4>
            <p className="text-center text-xs leading-normal text-label-assistive lg:text-lg">
              환경이 달라지면 커리어가 달라지니까.
              <br />
              멋쟁이사자처럼이 13년간 쌓아온 노하우로 끝까지 책임집니다.
            </p>
          </div>
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex w-full flex-col gap-4 overflow-hidden rounded-lg bg-[#333] p-4 lg:flex-row lg:gap-[57px] lg:p-6"
          >
            <div className="flex w-full flex-row items-center gap-4 border-b border-[#525252] pb-4 lg:h-[313px] lg:w-[314px] lg:border-0 lg:pb-0">
              <div className="h-[72px] w-[70px] overflow-hidden rounded lg:h-[313px] lg:w-[314px] lg:rounded-lg">
                <Image
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section11_img1.png"
                  layout="fill"
                  objectFit="cover"
                  className="!relative h-full w-full"
                  alt="-"
                />
              </div>
              <div className="flex flex-col lg:hidden">
                <span className="font-xs font-bold text-yellow-450">주강사</span>
                <p className="text-base font-bold text-white">신용기 강사님</p>
              </div>
            </div>
            <div className="flex flex-1 flex-col">
              <div className="mb-7 hidden flex-col gap-2 border-b border-label-neutral pb-7 lg:flex">
                <span className="text-2xl font-bold text-yellow-450">주강사</span>
                <p className="text-3xl font-bold text-white">신용기 강사님</p>
              </div>
              <ul className="flex flex-col lg:gap-1.5">
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section11} text-sm leading-normal text-label-assistive lg:text-lg`}
                >
                  전) SK C&C 씨앗 CLOUD & DevOps 주강사
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section11} text-sm leading-normal text-label-assistive lg:text-lg`}
                >
                  전) 신한은행 재직자 대상 Java & SQL 과정 주강사
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section11} text-sm leading-normal text-label-assistive lg:text-lg`}
                >
                  전) 멀티캠퍼스 백엔드 개발 취업자 과정 주강사
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section11} text-sm leading-normal text-label-assistive lg:text-lg`}
                >
                  전) 더존비즈온 웹 풀스택 개발자 양성 과정 주강사
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section11} text-sm leading-normal text-label-assistive lg:text-lg`}
                >
                  전) 위치 기반 포스팅 서비스 개발 외 다수 프로젝트 참여
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Section12_취업지원 */}
      <section id="support" className="bg-[#404040] py-[50px] lg:pb-36 lg:pt-[120px]">
        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">취업 지원</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              이력서, 포트폴리오, 면접까지
              <br />
              취업에 필요한 모든 과정을 도와드려요
            </h4>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} ${styles.curriculum_accordion_wrap_shortver} hidden flex-row overflow-hidden rounded-lg bg-trueGray-800 lg:mt-12 lg:flex`}
          >
            <ProgramTab detailList={supportDetailList} />
          </div>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} flex flex-col overflow-hidden lg:hidden`}
          >
            {supportDetailList.map((detail, idx) => (
              <ProgramAccordion contents={detail} key={detail.title} idx={idx} />
            ))}
          </ul>

          <p
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-10 text-center text-xs leading-normal text-label-alternative lg:mt-16 lg:text-base"
          >
            * 교육생 훈련 상황 및 회사 사정에 따라 <br className="block lg:hidden" />
            지원 내용은 변동될 수 있습니다.
          </p>
        </div>
      </section>

      {/* Section13_수강후기 */}
      <section className="bg-trueGray-800 py-[50px] lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">수강 후기</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              수료생 후기 모음
            </h4>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mx-auto hidden flex-col gap-4 lg:flex lg:gap-6"
          >
            <div className="relative flex flex-row flex-wrap rounded-lg bg-[#303030] p-4 lg:min-h-[124px] lg:py-5 lg:pl-[156px] lg:pr-6">
              <div className="mr-4 h-12 w-12 lg:absolute lg:left-6 lg:top-1/2 lg:h-[84px] lg:w-[108px] lg:-translate-y-1/2 lg:border-r lg:border-[#404040]">
                <img
                  className="h-full w-full object-cover lg:h-[84px] lg:w-[84px]"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section15_who1.png"
                  alt="-"
                />
              </div>
              <h6 className="h-12 flex-1 text-lg font-bold leading-normal text-white lg:h-auto lg:text-xl lg:leading-tight">
                새로운 기술을 도입해보는 과정을 배울 수 있었습니다.
              </h6>
              <p className="mt-4 w-full border-t border-[#404040] pt-4 text-base leading-normal text-label-assistive lg:mt-3 lg:border-0 lg:pt-0">
                이 교육을 통해서 클라우드 관련 교육도 받고 비용이 소모되는 클라우드 프로젝트도 할 수
                있어서 좋았습니다. 그리고 함께했던 수강생분들의 수준이 높아서 동기부여가{' '}
                <br className="hidden lg:block" />
                되었고, 새로운 기술을 도입해보는 과정이 뜻 깊었던 것 같습니다.
              </p>
            </div>

            <div className="relative flex flex-row flex-wrap rounded-lg bg-[#303030] p-4 lg:min-h-[124px] lg:py-5 lg:pl-[156px] lg:pr-6">
              <div className="mr-4 flex h-12 w-12 items-center justify-start lg:absolute lg:left-6 lg:top-1/2 lg:h-[84px] lg:w-[108px] lg:-translate-y-1/2 lg:border-r lg:border-[#404040]">
                <img
                  className="h-full w-full object-cover lg:h-[84px] lg:w-[84px]"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section15_who2.png"
                  alt="-"
                />
              </div>
              <h6 className="h-12 flex-1 text-lg font-bold leading-normal text-white lg:h-auto lg:text-xl lg:leading-tight">
                수강하길 정말 잘했습니다!
              </h6>
              <p className="mt-4 w-full border-t border-[#404040] pt-4 text-base leading-normal text-label-assistive lg:mt-3 lg:border-0 lg:pt-0">
                과정 시작 전에는 온라인 진행 방식에 대한 걱정이 많았었는데, 막상 시작하니 통학시간을
                절약함으로써 그 시간들을 개인 공부, 체력관리에 쓸 수 있는 점이 엄청 큰{' '}
                <br className="hidden lg:block" />
                장점이었고 만족감이 컸습니다.
              </p>
            </div>

            <div className="relative flex flex-row items-center justify-center rounded-lg bg-[#303030] p-4 lg:min-h-[124px] lg:py-5 lg:pl-[156px] lg:pr-6">
              <div className="mr-4 h-12 w-12 lg:absolute lg:left-6 lg:top-1/2 lg:h-[84px] lg:w-[108px] lg:-translate-y-1/2 lg:border-r lg:border-[#404040]">
                <img
                  className="h-full w-full object-cover lg:h-[84px] lg:w-[84px]"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section15_who3.png"
                  alt="-"
                />
              </div>
              <div className="flex w-full flex-col gap-3">
                <h6 className="h-12 flex-1 text-lg font-bold leading-normal text-white lg:h-7 lg:text-xl lg:leading-tight">
                  인프라 지식이 크게 상승했습니다.
                </h6>
                <p className="w-full text-base leading-normal text-label-assistive lg:h-6">
                  수업이 굉장히 좋아 클라우드와 같은 인프라 지식이 크게 상승하였습니다.
                </p>
              </div>
            </div>

            <div className="relative flex flex-row items-center justify-center rounded-lg bg-[#303030] p-4 lg:min-h-[124px] lg:py-5 lg:pl-[156px] lg:pr-6">
              <div className="mr-4 h-12 w-12 lg:absolute lg:left-6 lg:top-1/2 lg:h-[84px] lg:w-[108px] lg:-translate-y-1/2 lg:border-r lg:border-[#404040]">
                <img
                  className="h-full w-full object-cover lg:h-[84px] lg:w-[84px]"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section15_who4.png"
                  alt="-"
                />
              </div>
              <div className="flex w-full flex-col gap-3">
                <h6 className="h-12 flex-1 text-lg font-bold leading-normal text-white lg:h-7 lg:text-xl lg:leading-tight">
                  어려웠던 AWS를 배울 수 있었습니다.
                </h6>
                <p className="w-full text-base leading-normal text-label-assistive lg:h-6">
                  어려웠던 AWS의 다양한 기능들과 추가적인 다른 기능들까지 직접 프로젝트를 통해
                  배우고 적용해 볼 수 있어서 좋았습니다.
                </p>
              </div>
            </div>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="block lg:hidden"
          >
            <ReviewSliderItem contents={reviewSlideList} />
          </div>

          <p
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-10 text-center text-xs leading-normal text-label-assistive lg:mt-16 lg:text-base"
          >
            * 고용24 클라우드 엔지니어링 부트캠프 1기 수료생의 실제 후기
          </p>
        </div>
      </section>

      {/* Section14_To-be */}
      <section className="bg-gray-900 py-[50px] lg:pb-36 lg:pt-[120px]">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div className="mb-10 flex w-full flex-row items-center justify-center lg:mb-16 lg:items-end lg:justify-between">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="flex flex-col items-center justify-center gap-2 lg:items-start lg:justify-start lg:gap-4"
            >
              <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-left lg:text-4xl lg:leading-[1.4]">
                5개월 뒤, <br className="block lg:hidden" />
                당신이 그리게 될 커리어 로드맵
              </h4>
              <p className="text-center text-xs leading-normal text-label-assistive lg:text-left lg:text-lg">
                IT 직무 블루오션으로 떠오른 클라우드 엔지니어의
                <br />
                실제 업무와 시장 현 미래 전망, 신입 초봉 등 최신 정보가{' '}
                <br className="block lg:hidden" />
                궁금하다면 <br className="hidden lg:block" />
                멋쟁이사자처럼 블로그에서 <br className="block lg:hidden" />더 자세히 만나보세요.
              </p>
            </div>
            <Link
              href="https://abit.ly/kdtcld03_article_1_brunch"
              target="_blank"
              className="group hidden cursor-pointer flex-row items-center gap-2 rounded-lg border border-label-neutral px-5 py-4 hover:border-white hover:bg-white lg:flex"
            >
              <p className="text-base font-bold text-white group-hover:text-label-normal">
                아티클 보러가기
              </p>
              <img
                className="h-5 w-5 group-hover:hidden"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section14_icon.png"
                alt="go link"
              />
              <img
                className="hidden h-5 w-5 group-hover:block"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section14_icon_hover.png"
                alt="go link"
              />
            </Link>
          </div>
          <div className="flex flex-col gap-4 lg:flex-row lg:gap-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-1 flex-col gap-3 overflow-hidden rounded-lg bg-trueGray-800 p-4 lg:p-6"
            >
              <span className="max-w-fit rounded bg-[rgba(255,119,16,0.10)] px-2 text-xs font-bold text-yellow-450 lg:px-2.5 lg:text-lg">
                #1
              </span>
              <h6 className="text-base font-bold text-white lg:text-lg">클라우드 엔지니어</h6>
              <div className="-mt-1 flex flex-col lg:mt-0">
                <p
                  className={`${styles.text_dot} ${styles.text_dot_section14} text-sm font-medium text-label-alternative`}
                >
                  클라우드 솔루션 설계, 구축 및 관리
                </p>
                <p
                  className={`${styles.text_dot} ${styles.text_dot_section14} text-sm font-medium text-label-alternative`}
                >
                  CI/CD 워크플로우 구축
                </p>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="800"
              className="flex flex-1 flex-col gap-3 overflow-hidden rounded-lg bg-trueGray-800 p-4 lg:p-6"
            >
              <span className="max-w-fit rounded bg-[rgba(255,119,16,0.10)] px-2 text-xs font-bold text-yellow-450 lg:px-2.5 lg:text-lg">
                #2
              </span>
              <h6 className="text-base font-bold text-white lg:text-lg">DevOps 엔지니어</h6>
              <div className="-mt-1 flex flex-col lg:mt-0">
                <p
                  className={`${styles.text_dot} ${styles.text_dot_section14} text-sm font-medium text-label-alternative`}
                >
                  AWS 기반 서비스 인프라 운영 및 관리
                </p>
                <p
                  className={`${styles.text_dot} ${styles.text_dot_section14} text-sm font-medium text-label-alternative`}
                >
                  컨테이너 기반 서비스 개발 및 운영
                </p>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="1000"
              className="flex flex-1 flex-col gap-3 overflow-hidden rounded-lg bg-trueGray-800 p-4 lg:p-6"
            >
              <span className="max-w-fit rounded bg-[rgba(255,119,16,0.10)] px-2 text-xs font-bold text-yellow-450 lg:px-2.5 lg:text-lg">
                #3
              </span>
              <h6 className="text-base font-bold text-white lg:text-lg">시스템 엔지니어</h6>
              <div className="-mt-1 flex flex-col lg:mt-0">
                <p
                  className={`${styles.text_dot} ${styles.text_dot_section14} text-sm font-medium text-label-alternative`}
                >
                  IT 인프라 시스템 구축 및 서비스 운영 관리
                </p>
                <p
                  className={`${styles.text_dot} ${styles.text_dot_section14} text-sm font-medium text-label-alternative`}
                >
                  클라우드 구축 및 운영
                </p>
              </div>
            </div>
          </div>

          <Link
            href="https://abit.ly/kdtcld03_article_1_brunch"
            target="_blank"
            className="group mt-10 flex cursor-pointer flex-row items-center justify-center gap-2 rounded-lg border border-label-neutral px-2 py-3 hover:border-white hover:bg-white lg:hidden"
          >
            <p className="text-sm font-bold text-white group-hover:text-label-normal">
              아티클 보러가기
            </p>
            <img
              className="h-4 w-4 group-hover:hidden"
              src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section14_icon.png"
              alt="go link"
            />
            <img
              className="hidden h-4 w-4 group-hover:block"
              src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section14_icon_hover.png"
              alt="go link"
            />
          </Link>
        </div>
      </section>

      {/* Section15_사전설명회 */}
      <section className="bg-[#301704] py-[50px] lg:py-[120px]">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex w-full flex-col gap-2 lg:mb-16 lg:gap-4"
          >
            <h4 className="text-center text-2xl font-bold leading-[1.4] text-white lg:text-4xl">
              사전설명회 다시보기
            </h4>
            <p className="text-center text-sm leading-normal text-white lg:text-lg">
              아직도 클라우드 엔지니어 고민된다면,
              <br />
              2025년 클라우드 채용 트렌드 설명회에서 궁금했던
              <br />
              모든 것을 한 번에 해결하세요!
            </p>
          </div>
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="w-full"
            style={{
              position: 'relative',
              paddingTop: '56.25%',
            }}
          >
            <ReactPlayer
              alt="멋쟁이사자처럼 클라우드 엔지니어링 3기 사전설명회 Live"
              url="https://youtube.com/live/CtAtzmOAYQc?feature=share"
              controls={true}
              width="100%"
              height="100%"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
            />
          </div>
        </div>
      </section>

      {/* Section16_교육혜택 */}
      <section className="bg-trueGray-800 py-[50px] lg:pb-36 lg:pt-[120px]">
        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:items-start lg:justify-start lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">교육 혜택</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-left lg:text-4xl lg:leading-[1.4]">
              오로지 클라우드 엔지니어가
              <br />
              되겠다는 마음만 있으면 돼요
            </h4>
            <p className="text-center text-xs leading-normal text-label-assistive lg:text-left lg:text-lg">
              나머지는 멋쟁이사자처럼에서 모두 지원해 드릴게요
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section16_mediaquery} hidden flex-row flex-wrap gap-6 lg:flex`}
          >
            {benefitSlideList.map(({ desc, title, imgUrlPc }) => (
              <div
                className="flex h-[253px] w-[calc(25%-18px)] flex-col justify-between gap-10 rounded-lg bg-gray-900 px-6 py-5"
                key={title}
              >
                <div className="flex flex-col gap-1">
                  <h6 className="mb-1 text-lg font-bold text-white">{title}</h6>
                  <p className="whitespace-pre-wrap text-base leading-normal text-label-assistive">
                    {desc}
                  </p>
                </div>
                <img
                  src={imgUrlPc}
                  className="block h-[90px] w-full object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="block lg:hidden"
          >
            <BenefitSliderItem contents={benefitSlideList} />
          </div>
        </div>
      </section>

      {/* section17_일정 */}
      <section id="condition" className="bg-gray-900 py-20 lg:pb-[144px] lg:pt-[120px]">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-20 px-4 lg:mx-auto lg:flex-row lg:gap-6 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="w-full lg:w-auto lg:flex-1"
          >
            <div className="mb-6 lg:mb-8">
              <h4 className="text-center text-xl font-bold text-white lg:text-3xl">
                지원 및 선발 일정
              </h4>
            </div>
            <ul
              className={`${styles.section17_custom_box1} lg:min-h-[334px] lg:rounded-lg lg:bg-trueGray-800 lg:px-6 lg:py-5`}
            >
              {AfterCldApplyScheduleList.map(apply => (
                <li
                  className="flex flex-col items-start justify-center gap-2 rounded-b-none rounded-t-lg bg-trueGray-800 px-4 py-2 first-of-type:mb-3 first-of-type:rounded-lg first-of-type:border-0 last-of-type:rounded-b-lg last-of-type:border-0 lg:flex-row lg:gap-8 lg:rounded-none lg:border-b lg:border-[#404040] lg:px-0 lg:py-3 lg:first-of-type:mb-0 lg:first-of-type:border-b lg:first-of-type:pt-0 lg:last-of-type:pb-0"
                  key={apply.title}
                >
                  <b className="text-sm font-semibold leading-normal text-yellow-450 lg:w-[74px] lg:whitespace-pre-line lg:text-base lg:font-bold">
                    {apply.title}
                  </b>
                  <div className="w-full flex-1 lg:w-auto">
                    {apply.content ? (
                      <p className="whitespace-pre-line text-sm text-label-assistive lg:whitespace-normal lg:text-base">
                        {apply.content}
                      </p>
                    ) : (
                      <ul className="-my-2 flex w-full flex-col lg:-my-1.5 lg:flex-1">
                        {apply.contents?.map(item => (
                          <li
                            key={`${apply.title}-${item}`}
                            className="border-b border-[#404040] py-2 text-sm text-label-assistive last-of-type:border-0 lg:py-1.5 lg:text-base"
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="w-full lg:w-auto lg:flex-1"
          >
            <div className="mb-6 lg:mb-8">
              <h4 className="text-center text-xl font-bold text-white lg:text-3xl">교육일정</h4>
            </div>
            <ul
              className={`${styles.section17_custom_box2} lg:min-h-[334px] lg:rounded-lg lg:bg-trueGray-800 lg:px-6 lg:py-5`}
            >
              {CldEduScheduleList.map(edu => (
                <li
                  className="flex flex-row items-start justify-center gap-2 bg-trueGray-800 px-4 py-2 last-of-type:mt-3 last-of-type:flex-col lg:gap-11 lg:rounded-none lg:px-0 lg:py-3 lg:first-of-type:mb-0 lg:first-of-type:pt-0 lg:last-of-type:mt-0 lg:last-of-type:flex-row lg:last-of-type:pb-0"
                  key={edu.title}
                >
                  <b className="w-[63px] text-sm font-semibold leading-normal text-yellow-450 lg:w-[57px] lg:text-base lg:font-bold">
                    {edu.title}
                  </b>
                  <div className="w-full flex-1 lg:w-auto">
                    {edu.content ? (
                      <p className="whitespace-pre-line text-sm text-label-assistive lg:whitespace-nowrap lg:text-base">
                        {edu.content}
                      </p>
                    ) : (
                      <ul className="-my-2 flex w-full flex-col lg:-my-1.5 lg:flex-1">
                        {edu.contents?.map(item => (
                          <li
                            key={`${edu.title}-${item}`}
                            className="border-b border-[#404040] py-2 text-sm text-label-assistive last-of-type:border-0 lg:whitespace-pre-line lg:py-1.5 lg:text-base"
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* section18_FAQ */}
      <section className="bg-white pb-[90px] pt-[50px] lg:py-[120px]">
        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="300"
          className="mx-auto w-full max-w-7xl px-4 lg:px-6"
        >
          <h4 className="mb-4 text-center font-bold text-label-normal lg:mb-6 lg:text-left lg:text-4xl">
            자주 묻는 질문
          </h4>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mx-auto mb-10 flex max-w-[324px] flex-wrap items-center justify-center gap-1.5 lg:mb-16 lg:max-w-none lg:flex-nowrap lg:justify-start lg:gap-2"
          >
            {bootCampFaqTabList.map(tabItem => {
              const isActive = tabItem.value === faqTab
              return (
                <li
                  className={`${
                    isActive
                      ? 'bg-yellow-450 text-white'
                      : 'border border-normal bg-white text-gray-400'
                  } cursor-pointer rounded-full px-5 py-1.5 text-xs font-bold lg:px-6 lg:py-2 lg:text-sm`}
                  onClick={() => onClickFaqTab(tabItem.value)}
                  key={tabItem.value}
                >
                  {tabItem.label}
                </li>
              )
            })}
          </ul>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mx-auto flex flex-col"
          >
            {faqList.map(faq => (
              <li
                className={`${styles.faqItem} border-b border-[#E5E5E5] py-4 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0 lg:py-6`}
                key={faq.question}
              >
                <details className="group overflow-hidden">
                  <summary className="cursor-pointer list-none group-open:pb-1 lg:group-open:pb-2">
                    <div className="flex w-full items-center justify-between gap-4">
                      <div>
                        <p
                          className={`${styles.faq_item_title} text-sm font-semibold text-label-normal lg:text-lg`}
                        >
                          {faq.question}
                        </p>
                      </div>
                      <ChevronDownIcon className="w-4 shrink-0 text-gray-500 group-open:rotate-180 lg:w-6" />
                    </div>
                  </summary>
                  <div className="pl-5 lg:pl-[22px]">
                    <div className="whitespace-pre-wrap text-sm leading-normal text-gray-500 lg:text-base">
                      {faq.answer && (
                        <span className="max-w-full">
                          {faq.answer}
                          {faq.externalUrl1 && (
                            <>
                              {' '}
                              자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.
                              <br />-{' '}
                              <Link href={faq.externalUrl1} target="_blank" className="underline">
                                {' '}
                                {faq.urlName1}
                              </Link>
                              {faq.secondAnswer}
                            </>
                          )}
                          {faq.externalUrl2 && (
                            <>
                              <br />-{' '}
                              <Link href={faq.externalUrl2} target="_blank" className="underline">
                                {' '}
                                {faq.urlName2}
                              </Link>
                            </>
                          )}
                        </span>
                      )}
                      {faq.answerList &&
                        faq.answerList.map(el => (
                          <p key={el} className="text-sm text-gray-500 lg:text-base">
                            {el}
                          </p>
                        ))}
                    </div>
                  </div>
                </details>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  )
}

export default CloudKlass3rd
